import { render, staticRenderFns } from "./ConfirmID.vue?vue&type=template&id=12ecd2f7"
import script from "./ConfirmID.vue?vue&type=script&lang=js"
export * from "./ConfirmID.vue?vue&type=script&lang=js"
import style0 from "./ConfirmID.vue?vue&type=style&index=0&id=12ecd2f7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VFlex,VLayout,VTextField})
